export const UPDATE_LIBRARY = "UPDATE_LIBRARY";

export const UpdateLibrary = (val) => {
    return {
        type: UPDATE_LIBRARY,
        value: val
    };
};
